import React, { forwardRef } from 'react'

const GeminiScrollbarWrapper = forwardRef(({ children }, forwardedRef) => {
  return <div ref={forwardedRef}>{children}</div>
})

export default GeminiScrollbarWrapper
